import React from 'react';

import {
  Chip,
  Tooltip
} from '@mui/material';

import { TILE_ACCENT } from './SummaryTiles';

// The repair verdicts be-core returns for a vendor or a customer, and how each
// one should read. Keys mirror app_pay/services/vendor_repair_service.py and
// app_receive/services/customer_repair_service.py — a status missing from here
// still renders, just in the neutral colour.
export const HEALTH_ACCENT = {
  OK: TILE_ACCENT.good,
  FLAG_CONFLICT: TILE_ACCENT.bad,
  DOMESTIC_NO_CONFIG: TILE_ACCENT.bad,
  INTERNATIONAL_NO_CONFIG: TILE_ACCENT.bad,
  DOMESTIC_UNCHECKED: TILE_ACCENT.info,
  CONFIG_WITHOUT_FLAG: TILE_ACCENT.warn,
  UNASSIGNED: TILE_ACCENT.neutral,
};

export const HEALTH_LABEL = {
  OK: "Healthy",
  FLAG_CONFLICT: "Both flags set",
  DOMESTIC_NO_CONFIG: "Domestic, no bank account",
  INTERNATIONAL_NO_CONFIG: "International, no beneficiary",
  DOMESTIC_UNCHECKED: "Domestic (not verifiable)",
  CONFIG_WITHOUT_FLAG: "Config with no flag",
  UNASSIGNED: "Unassigned",
};

export const healthAccent = (status) => HEALTH_ACCENT[status] || TILE_ACCENT.neutral;
export const healthLabel = (status) => HEALTH_LABEL[status] || status || "Unknown";

/**
 * @param {object} health - the `health` block from the internal serializer
 *                          ({ status, detail, repairable, ... })
 */
const PartyHealthChip = ({ health }) => {
  const status = health?.status;
  const accent = healthAccent(status);

  return (
    <Tooltip title={health?.detail || ""}>
      <Chip
        size='small'
        label={healthLabel(status)}
        sx={{
          color: accent,
          border: `1px solid ${accent}60`,
          background: `${accent}14`,
          fontWeight: 600,
        }}
        />
    </Tooltip>
  )
}

export default PartyHealthChip;
